import React, { useState } from "react";

interface BugReportButtonProps {
  onOpen: () => void;
}

export default function BugReportButton({ onOpen }: BugReportButtonProps) {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <button
      onClick={onOpen}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="relative group w-9 h-9"
      title="Report a bug"
    >
      {/* Main Button - matches the style of other circle buttons in right rail */}
      <div className="relative w-full h-full rounded-full bg-white/5 ring-1 ring-white/10 hover:bg-red-500/20 hover:ring-red-500/40 transition-all duration-300 flex items-center justify-center">
        {/* Bug Icon */}
        <svg
          className="w-4 h-4 text-white/60 group-hover:text-red-300 transition-colors duration-300"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>

        {/* Single Flash Animation - happens once on mount */}
        <div className="absolute inset-0 rounded-full bg-red-400/20 animate-[ping_1s_ease-out_1]" />
      </div>

      {/* Tooltip */}
      {isHovered && (
        <div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap animate-in fade-in slide-in-from-right-2 duration-200">
          <div className="rounded-lg bg-black/90 border border-red-500/30 px-3 py-2 text-xs font-semibold text-red-200 shadow-xl backdrop-blur-sm">
            Report a Bug
            <div className="absolute left-full top-1/2 -translate-y-1/2 -ml-1 h-2 w-2 rotate-45 bg-black/90 border-r border-t border-red-500/30" />
          </div>
        </div>
      )}
    </button>
  );
}
